<template>
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4 col-lg-2 columns customer-service">
                    <h6> {{ siteDatas.footerMenuCMS[0].customer_service_menu }} </h6>
                    <ul>
                        <li><span>{{ siteDatas.supportCMS.phone }}</span></li>
                        <li><router-link to="/support">Support</router-link></li>
                        <li><router-link to="/covid-safety">COVID-19 Health &amp; Safety</router-link></li>
                        <li><router-link to="/accessibility-statement">Accessibility Statement</router-link></li>
                    </ul>
                </div>
                <div class="col-12 col-md-4 col-lg-2 columns about-us">
                    <h6>{{ siteDatas.footerMenuCMS[0].about_us_menu }}</h6>
                    <ul>
                        <li><router-link to="/blog">Blog</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><router-link to="/buy-in-bulk">Buy in Bulk</router-link></li>
                        <li><router-link to="/custom-quote">Custom Quote</router-link></li>
                    </ul>
                </div>
                
                <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0 columns subscribe  desktop-vcard-footer">
                    <h6 class='hide-for-medium-only'>{{ siteDatas.footerMenuCMS[0].follow_us }}</h6>
                    <div class="form-wrap">
                        <div class="footer-icons-container d-flex align-items-center justify-content-center">
                            <div class="footer-icons">
                                <a :href="siteDatas.siteCMS.follow_facebook_url" target="_blank"><i class="fab fa-facebook-f"></i></a>
                                <a :href="siteDatas.siteCMS.follow_twitter_url" target="_blank"><i class="fab fa-twitter"></i></a>
                                <a :href="siteDatas.siteCMS.follow_instagram_url" target="_blank"><i class="fab fa-instagram"></i></a>
                            </div>
                            <div class="d-flex flex-column flex-sm-row align-items-center">
                                <!-- <a class="partner_link mr-sm-2 mr-md-3 mr-lg-4" href="http://neutrix.co" target="_blank">
                                    <img width="130" :src="imageCopyrightPath + siteDatas.siteCMS.copyright_logo" alt="geekbuyback.com Footer logo">
                                </a> -->
                                <img :src="imagePath + siteDatas.siteCMS.fotter_logo" width="100" height="" class="">
                            </div>
                        </div>
                        <hr>
                        <div class="text-center">
                            <router-link to="/privacy-policy">Privacy Policy</router-link>
                            <span class='spacer'>|</span>
                            <router-link to="/website-terms-and-condition">Terms and Conditions</router-link>
                            <span class='spacer'>|</span>
                            <router-link to="/user-agreement">User Agreement</router-link>
                            <span class='spacer'>|</span>
                            <router-link to="/law-enforcement">Law Enforcement</router-link>
                        </div>
                        
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-2 columns connect-with-us" style="text-align:right;">
                    <h6>{{ siteDatas.footerMenuCMS[0].quick_links_menu }}</h6>
                    <ul>
                        <li v-for="(row,index) in siteDatas.footerLinkCMS" :key="index">
                            <a :href="row.link" target="_blank" class="social">{{row.title}}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0 columns subscribe  mobile-vcard-footer">
                    <h6 class='hide-for-medium-only text-center' style="padding-top:2.5rem;">{{ siteDatas.footerMenuCMS[0].follow_us }}</h6>
                    <div class="form-wrap">
                        <div class="footer-icons-container flex-column text-center align-items-center">
                            <div class="footer-icons">
                                <a :href="siteDatas.siteCMS.follow_facebook_url" target="_blank"><i class="fab fa-facebook-f"></i></a>
                                <a :href="siteDatas.siteCMS.follow_twitter_url" target="_blank"><i class="fab fa-twitter"></i></a>
                                <a :href="siteDatas.siteCMS.follow_instagram_url" target="_blank"><i class="fab fa-instagram"></i></a>
                            </div>
                            <div class="align-items-center text-center" style="padding-top:2.5rem;">
                                <!-- <a class="partner_link  flex-column" href="http://neutrix.co" target="_blank">
                                    <img width="130" :src="imageCopyrightPath + siteDatas.siteCMS.copyright_logo" alt="geekbuyback.com Footer logo">
                                </a> -->
                                <img :src="imagePath + siteDatas.siteCMS.fotter_logo" width="100" height="" class="flex-column text-right right">
                            </div>
                        </div>
                        <hr>
                        <div class="text-center">
                            <router-link to="/privacy-policy">Privacy Policy</router-link>
                            <span class='spacer'>|</span>
                            <router-link to="/website-terms-and-condition">Terms and Conditions</router-link>
                            <span class='spacer'>|</span>
                            <router-link to="/user-agreement">User Agreement</router-link>
                            <span class='spacer'>|</span>
                            <router-link to="/law-enforcement">Law Enforcement</router-link>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="bottom">
            <div class="container text-center">
                <p class="mb-0">
                    Copyright &copy; 2022 | {{ siteDatas.siteCMS.copyright_text }}
                </p>
            </div>
        </div>
    </footer>
</template>
<style scoped>
    @media only screen and (max-width: 600px) {
        .customer-service {
            text-align: center !important;
            border-bottom:1px #494849 inset;
            padding-top: 10px;
            padding-bottom: 2.5rem; 
        }

        .about-us,.connect-with-us {
            text-align: center !important;
            padding-bottom: 2.5rem; 
            border-bottom:1px #494849 inset;
            padding-top: 2.5rem;
        }
        .desktop-vcard-footer{
            display: none !important;
        }
        .mobile-vcard-footer{
            display: block !important;
        }
    }
    
    @media only screen and (min-width: 600px) {
        .customer-service {
        }

        .about-us,.connect-with-us {
          
        }
        .desktop-vcard-footer{
            display: inline-block !important;
        }
        .mobile-vcard-footer{
            display: none !important;
        }
    }
</style>
<script>
export default {
    name: "SiteFooter",
    data() {
        return {
            data: [],
            imagePath: this.$api + "upload/fotter_logo/",
            imageCopyrightPath: this.$api + "upload/copyright_logo/"
        } 
    },
    props: ['siteDatas']
}
</script>